var _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgUnsubscribe = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 167,
  height: 153,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M140.25 25.5H12.75v102h127.5zM127.5 46l-51 31.875L25.5 46v-7.75l51 31.875 51-31.875z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 134,
  cy: 39,
  r: 33,
  fill: "#fff",
  transform: "rotate(-90 134 39)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#D23228",
  d: "M134 11c-15.456 0-28 12.544-28 28s12.544 28 28 28 28-12.544 28-28-12.544-28-28-28m0 50.4c-12.376 0-22.4-10.024-22.4-22.4 0-5.18 1.764-9.94 4.732-13.72l31.388 31.388A22.13 22.13 0 0 1 134 61.4m17.668-8.68L120.28 21.332A22.13 22.13 0 0 1 134 16.6c12.376 0 22.4 10.024 22.4 22.4 0 5.18-1.764 9.94-4.732 13.72"
})));
export { SvgUnsubscribe as ReactComponent };
export default __webpack_public_path__ + "f8d0b96aefbf2f51efd56a705ccfa2ed.svg";